import React, { useEffect } from "react";
import StrategicServices from "../components/Service/StrategicServices";
import LogisticsServices from "../components/Service/LogisticsServices";
import Leasing from "../components/Service/Leasing";
import SwiperBrands from "../components/Home/SwiperBrands";
import PromoWeb from "../components/Service/PromoWeb"

const HomePage = () => {
  useEffect(() => {
    document.title = "Servicios | Hydroluz";
    window.scrollTo(0, 0);
  }, []);

  return (
    <main>
      <StrategicServices />
      <LogisticsServices />
      <SwiperBrands />
      <PromoWeb />
      <Leasing />
    </main>
  );
};

export default HomePage;
